import { FlexBox } from '@ardoq/layout';
import { colors, s16, s24, s32, s8 } from '@ardoq/design-tokens';
import styled from 'styled-components';

export type Spacing = 'none' | 'small' | 'medium' | 'large' | 'xlarge';

export const SPACING_LOOKUP: Record<Spacing, string> = {
  none: '0',
  small: s8,
  medium: s16,
  large: s24,
  xlarge: s32,
};

export const IslandSectionContainer = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'none',
})<{ $spacing?: Spacing }>`
  padding: ${({ $spacing = 'xlarge' }) => SPACING_LOOKUP[$spacing]};
  border-bottom: 1px solid ${colors.borderAction};
  &:only-child {
    border-bottom: 0;
  }
  &:last-child {
    border-bottom: none;
  }
`;
